import React from "react";
import { SwitchOption as CoreSwitchOption } from "@jelly/ui";

import styles from "./SwitchOption.module.scss";

export type SwitchOptionProps = React.ComponentProps<typeof CoreSwitchOption>;

export const SwitchOption: React.FC<SwitchOptionProps> = (props) => {
  return <CoreSwitchOption {...props} style={styles} />;
};
